module.exports = __webpack_public_path__ + "static/media/banner.a4e6f3f3.jpg";